<template>
	<article class="square-detail-m-skeleton" aria-hidden="true">
		<span class="square-detail-m-skeleton__media"></span>
		<section class="square-detail-m-skeleton__body">
			<span class="square-detail-m-skeleton__title"></span>
			<span class="square-detail-m-skeleton__title square-detail-m-skeleton__title--short"></span>
			<span class="square-detail-m-skeleton__meta"></span>

			<div class="square-detail-m-skeleton__author">
				<span class="square-detail-m-skeleton__avatar"></span>
				<span class="square-detail-m-skeleton__name"></span>
				<span class="square-detail-m-skeleton__follow"></span>
			</div>

			<div class="square-detail-m-skeleton__actions">
				<span></span>
				<span></span>
			</div>

			<div class="square-detail-m-skeleton__comment-card">
				<span class="square-detail-m-skeleton__comment-title"></span>
				<span class="square-detail-m-skeleton__comment-line"></span>
				<span class="square-detail-m-skeleton__comment-input"></span>
			</div>
		</section>
	</article>
</template>

<style scoped>
.square-detail-m-skeleton {
	width: 750px;
	max-width: 100%;
	min-height: 100vh;
	margin: 0 auto;
	background: #fff;
	box-sizing: border-box;
}

.square-detail-m-skeleton span {
	display: block;
	background: linear-gradient(90deg, #eee 25%, #fafafa 42%, #eee 62%);
	background-size: 300% 100%;
	animation: square-detail-m-shimmer 1.35s ease-in-out infinite;
}

.square-detail-m-skeleton__media {
	width: 100%;
	height: 422px;
}

.square-detail-m-skeleton__body {
	padding: 24px 30px 40px;
}

.square-detail-m-skeleton__title {
	width: 88%;
	height: 32px;
	border-radius: 7px;
}

.square-detail-m-skeleton__title--short {
	width: 58%;
	margin-top: 16px;
}

.square-detail-m-skeleton__meta {
	width: 230px;
	height: 24px;
	margin-top: 24px;
	border-radius: 6px;
}

.square-detail-m-skeleton__author {
	display: flex;
	align-items: center;
	gap: 16px;
	margin-top: 24px;
}

.square-detail-m-skeleton__avatar {
	flex: 0 0 64px;
	width: 64px;
	height: 64px;
	border-radius: 50%;
}

.square-detail-m-skeleton__name {
	width: 210px;
	height: 28px;
	border-radius: 6px;
}

.square-detail-m-skeleton__follow {
	width: 112px;
	height: 48px;
	margin-left: auto;
	border-radius: 8px;
}

.square-detail-m-skeleton__actions {
	display: flex;
	gap: 20px;
	margin-top: 24px;
}

.square-detail-m-skeleton__actions span {
	width: 136px;
	height: 64px;
	border-radius: 8px;
}

.square-detail-m-skeleton__comment-card {
	margin-top: 24px;
	padding: 24px;
	border: 1px solid #efefef;
	border-radius: 16px;
}

.square-detail-m-skeleton__comment-title {
	width: 160px;
	height: 28px;
	border-radius: 6px;
}

.square-detail-m-skeleton__comment-line {
	width: 76%;
	height: 22px;
	margin-top: 24px;
	border-radius: 5px;
}

.square-detail-m-skeleton__comment-input {
	width: 100%;
	height: 68px;
	margin-top: 24px;
	border-radius: 34px;
}

@keyframes square-detail-m-shimmer {
	to {
		background-position: -100% 0;
	}
}
</style>
